import moment from "moment";

class Date {
  public static ofText(value: string): Date {
    const date: Date = new Date();
    if (value && value !== "") {
      date.value = moment(value);
    }

    return date;
  }

  public value: moment.Moment;

  constructor() {
    this.value = moment();
  }

  public asText(): string {
    return moment.isMoment(this.value) ? this.value.format('YYYY/MM/DD') : "";
  }

  public asISOText(): string {
    return moment.isMoment(this.value) ? this.value.format('YYYY-MM-DD') : "";
  }
}

export default Date;
